import React from 'react';

interface VideoIconProps {
    size?: number;
    color?: string;
}

export const VideoIcon: React.FC<VideoIconProps> = ({ size = 15, color = "#14AE5C" }) => {
    const scale = size / 15; // 15 is the base width from the original SVG
    const height = 9 * scale; // Maintain aspect ratio
    
    return (
        <svg 
            width={size} 
            height={height} 
            viewBox="0 0 15 9" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M0 1.5C0 1.10218 0.206775 0.720644 0.574837 0.43934C0.942899 0.158035 1.4421 0 1.96262 0H7.85047C8.37099 0 8.87018 0.158035 9.23825 0.43934C9.60631 0.720644 9.81308 1.10218 9.81308 1.5V7.5C9.81308 7.89782 9.60631 8.27936 9.23825 8.56066C8.87018 8.84196 8.37099 9 7.85047 9H1.96262C1.4421 9 0.942899 8.84196 0.574837 8.56066C0.206775 8.27936 0 7.89782 0 7.5V1.5ZM11.6174 2.3295C11.4545 2.39174 11.3174 2.48743 11.2215 2.60586C11.1257 2.72428 11.0749 2.86075 11.0748 3V6C11.0749 6.13925 11.1257 6.27572 11.2215 6.39414C11.3174 6.51257 11.4545 6.60826 11.6174 6.6705L13.58 7.4205C13.7296 7.47762 13.8958 7.50459 14.0628 7.49884C14.2299 7.49309 14.3922 7.45481 14.5345 7.38765C14.6767 7.32048 14.7942 7.22664 14.8756 7.11505C14.9571 7.00345 14.9999 6.87779 15 6.75V2.25C14.9999 2.12221 14.9571 1.99655 14.8756 1.88495C14.7942 1.77336 14.6767 1.67952 14.5345 1.61235C14.3922 1.54519 14.2299 1.50691 14.0628 1.50116C13.8958 1.49541 13.7296 1.52238 13.58 1.5795L11.6174 2.3295Z" 
                fill={color}
            />
        </svg>
    );
};
